import React from 'react'
import PropTypes from 'prop-types'

const FilterHeader = ({ onClose }) => (
  <div className="d-flex justify-content-between align-items-center bg-success text-white p-3">
    <h5 className="m-0">Filtrer les données</h5>
    <button type="button" className="close text-white" onClick={onClose}>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
)

FilterHeader.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default FilterHeader